export const OVERVIEW_PERSISTENCE_KEY = '/overview';

export const DEFAULT_SELECTED_METRICS = [
  'AppSubscribers',
  'AppUniqueDevices',
  'user_session_active_time',
  'user_session_count',
];
